import React, { forwardRef } from 'react'

import { BaseLink, type BaseLinkProps } from './BaseLink'

export interface TextButtonProps
  extends BaseLinkProps,
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'color'> {
  children: React.ReactNode;
  disabled?: boolean;
}

export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(({
  children,
  disabled,
  type = 'button',
  ...props
}, forwardedRef) => {
  return (
    <BaseLink {...props}>
      <button disabled={disabled} type={type} ref={forwardedRef}>
        {children}
      </button>
    </BaseLink>
  )
})
